<script setup lang="ts">
import { HomeButton } from '@/components/home'
import KokomoIcon from '@/assets/images/kokomo-icon.png'
import { useKokomo } from '@/composables/game/kokomo'

withDefaults(defineProps<{
  containerClass?: string
}>(), {
  containerClass: '',
})

const { countdownForKokomoEnd } = useKokomo()
</script>

<template>
  <HomeButton
    variant="bottom"
    label="Kokomo"
    :countdown="{ value: countdownForKokomoEnd, dangerThreshold: 3600 * 12 }"
    :container-class="containerClass"
    button-class="bg-[linear-gradient(180deg,#7C3AED_0%,#F59E0B_100%)] p-0.5 overflow-hidden"
  >
    <img
      class="size-full object-cover rounded-[8px]"
      :src="KokomoIcon"
      alt="Kokomo"
    >
  </HomeButton>
</template>
